/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ClarificationRequestFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateClarificationRequestInput = {
  content: string
}

export type UpdateClarificationRequestInput = {
  content: string
  id: string
}

export type CreateClarificationRequestMutationVariables = Exact<{
  resourceType: string
  id: string
  input: Types.CreateClarificationRequestInput
}>

export type CreateClarificationRequestMutation = {
  __typename: "Mutation"
  clarificationRequest: {
    __typename: "ClarificationRequest"
    id: string
    content: string
    createdAt: string
    updatedAt: string
    lastUpdatedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type UpdateClarificationRequestMutationVariables = Exact<{
  resourceType: string
  id: string
  input: Types.UpdateClarificationRequestInput
}>

export type UpdateClarificationRequestMutation = {
  __typename: "Mutation"
  clarificationRequest: {
    __typename: "ClarificationRequest"
    id: string
    content: string
    createdAt: string
    updatedAt: string
    lastUpdatedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type DeleteClarificationRequestMutationVariables = Exact<{
  resourceType: string
  id: string
}>

export type DeleteClarificationRequestMutation = {
  __typename: "Mutation"
  clarificationRequest: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateClarificationRequestDocument = gql`
  mutation CreateClarificationRequest(
    $resourceType: String!
    $id: ID!
    $input: CreateClarificationRequestInput!
  ) {
    clarificationRequest: createClarificationRequest(
      resourceType: $resourceType
      id: $id
      input: $input
    )
      @rest(
        type: "ClarificationRequest"
        method: "POST"
        endpoint: "clarificationRequest"
        path: "/project-list/{args.resourceType}/{args.id}/clarification-request"
        bodySerializer: "clarificationRequest"
      ) {
      ...ClarificationRequest
    }
  }
  ${ClarificationRequestFragmentDoc}
`
export type CreateClarificationRequestMutationFn = Apollo.MutationFunction<
  CreateClarificationRequestMutation,
  CreateClarificationRequestMutationVariables
>

/**
 * __useCreateClarificationRequestMutation__
 *
 * To run a mutation, you first call `useCreateClarificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClarificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClarificationRequestMutation, { data, loading, error }] = useCreateClarificationRequestMutation({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClarificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClarificationRequestMutation,
    CreateClarificationRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateClarificationRequestMutation,
    CreateClarificationRequestMutationVariables
  >(CreateClarificationRequestDocument, options)
}
export type CreateClarificationRequestMutationHookResult = ReturnType<
  typeof useCreateClarificationRequestMutation
>
export type CreateClarificationRequestMutationResult =
  Apollo.MutationResult<CreateClarificationRequestMutation>
export type CreateClarificationRequestMutationOptions =
  Apollo.BaseMutationOptions<
    CreateClarificationRequestMutation,
    CreateClarificationRequestMutationVariables
  >
export const UpdateClarificationRequestDocument = gql`
  mutation UpdateClarificationRequest(
    $resourceType: String!
    $id: ID!
    $input: UpdateClarificationRequestInput!
  ) {
    clarificationRequest: updateClarificationRequest(
      resourceType: $resourceType
      id: $id
      input: $input
    )
      @rest(
        type: "ClarificationRequest"
        method: "PUT"
        endpoint: "clarificationRequest"
        path: "/project-list/{args.resourceType}/{args.id}/clarification-request"
        bodySerializer: "clarificationRequest"
      ) {
      ...ClarificationRequest
    }
  }
  ${ClarificationRequestFragmentDoc}
`
export type UpdateClarificationRequestMutationFn = Apollo.MutationFunction<
  UpdateClarificationRequestMutation,
  UpdateClarificationRequestMutationVariables
>

/**
 * __useUpdateClarificationRequestMutation__
 *
 * To run a mutation, you first call `useUpdateClarificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClarificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClarificationRequestMutation, { data, loading, error }] = useUpdateClarificationRequestMutation({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClarificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClarificationRequestMutation,
    UpdateClarificationRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateClarificationRequestMutation,
    UpdateClarificationRequestMutationVariables
  >(UpdateClarificationRequestDocument, options)
}
export type UpdateClarificationRequestMutationHookResult = ReturnType<
  typeof useUpdateClarificationRequestMutation
>
export type UpdateClarificationRequestMutationResult =
  Apollo.MutationResult<UpdateClarificationRequestMutation>
export type UpdateClarificationRequestMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateClarificationRequestMutation,
    UpdateClarificationRequestMutationVariables
  >
export const DeleteClarificationRequestDocument = gql`
  mutation DeleteClarificationRequest($resourceType: String!, $id: ID!) {
    clarificationRequest: deleteClarificationRequest(
      resourceType: $resourceType
      id: $id
    )
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/{args.resourceType}/{args.id}/clarification-request"
      ) {
      success
    }
  }
`
export type DeleteClarificationRequestMutationFn = Apollo.MutationFunction<
  DeleteClarificationRequestMutation,
  DeleteClarificationRequestMutationVariables
>

/**
 * __useDeleteClarificationRequestMutation__
 *
 * To run a mutation, you first call `useDeleteClarificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClarificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClarificationRequestMutation, { data, loading, error }] = useDeleteClarificationRequestMutation({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClarificationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClarificationRequestMutation,
    DeleteClarificationRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteClarificationRequestMutation,
    DeleteClarificationRequestMutationVariables
  >(DeleteClarificationRequestDocument, options)
}
export type DeleteClarificationRequestMutationHookResult = ReturnType<
  typeof useDeleteClarificationRequestMutation
>
export type DeleteClarificationRequestMutationResult =
  Apollo.MutationResult<DeleteClarificationRequestMutation>
export type DeleteClarificationRequestMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteClarificationRequestMutation,
    DeleteClarificationRequestMutationVariables
  >
